/**
 * Check and return true if an object is type of string
 */
export function isString(obj) {
    return typeof obj === "string";
}
/**
 * Check and return true if an object is type of number
 */
export function isNumber(obj) {
    return typeof obj === "number";
}
/**
 * Check and return true if an object is type of Function
 */
export function isFunction(obj) {
    return typeof obj === "function";
}



//////////////////
// WEBPACK FOOTER
// ./~/ng2-toasty/src/toasty.utils.js
// module id = 421
// module chunks = 7